<template>
  <div class="w-full bg-grayCust-270  text-black">
    <div class="flex items-start justify-center  pt-0 sm2:px-6 sm2:pb-6">
      <div class="flex items-center">
        <div
          class="flex items-center justify-center"
          style="width:34px;height:34px;"
        >
          <img
            :src="cdn('/images/site_created_img.png')"
            class="h-8 w-10"
          >
        </div>
        <div class="ml-1.5 ">
          <h4
            v-if="template.is_monetized"
            class="text-base  font-normal text-grayCust-1550"
          >
            <span v-if="price > 0">{{ $t('we_have_created_a_copy_of_your_purchased_template') }}</span>
            <span v-else>{{ $t('we_have_created_a_copy_of_free_template') }}</span>
          </h4>
          <h4
            v-else
            class="text-base  font-normal text-grayCust-1550"
          >
            {{ $t('your_new_wordpress_website_ready') }}
          </h4>
        </div>
      </div>
    </div>
    <div class="mt-6 rounded-lg border border-grayCust-100 p-4 sm2:mt-0 sm2:p-6">
      <div
        v-if="detail.wp_url"
        class="flex flex-wrap items-center md:flex-nowrap"
      >
        <div class="flex items-center">
          <img
            :src="cdn('images/globe-icon.svg')"
            class="mr-2"
            alt=""
            srcset=""
          >
          <h4 class="w-32 text-base font-medium text-grayCust-600 md:text-sm">
            {{ $t('url') }}
          </h4>
        </div>
        <a
          :href="detail.wp_url"
          target="_blank"
          class="flex flex-wrap items-center md:flex-nowrap"
        >
          <p class="cursor-pointer truncate border-b border-dashed border-primary-900 text-base font-medium text-primary-900 sm:max-w-[250px] sm2:ml-2 sm2:max-w-[300px]">{{ websiteUrl }}</p>
          <div class="btn-focus mt-2 cursor-pointer sm:ml-1.5 sm2:mt-0">
            <span class="btn-focus focus:outline-0 focus-visible:outline-0">
              <LinkIcon class="mr-2 size-4" />
            </span>
          </div>
        </a>
      </div>
      <div
        v-if="detail.wp_username"
        class="mt-3.5 flex flex-wrap items-start md:flex-nowrap"
      >
        <div class="flex items-center">
          <img
            :src="cdn('images/user-icon.svg')"
            class="mr-2"
            alt=""
            srcset=""
          >
          <h4 class="w-32 text-base font-medium text-grayCust-600 md:text-sm">
            {{ $t('username') }}
          </h4>
        </div>
        <div class="flex items-center">
          <input
            ref="username"
            type="text"
            class="absolute p-0 opacity-0"
            :value="detail.wp_username"
          >
          <p class="username-width ml-2 break-all text-base font-medium text-grayCust-600 md:text-sm">
            {{ detail.wp_username }}
          </p>
          <button
            type="button"
            class="ml-2 cursor-pointer"
            @click="copyToClipboard('username')"
          >
            <Tooltip :tooltip-text="siteDetails.username ? $t('copied') : $t('copy')">
              <CheckIcon
                v-if="siteDetails.username"
                class="size-4 text-grayCust-800"
              />
              <CopyGrayIcon
                v-else
                class="size-4 text-primary-900"
              />
            </Tooltip>
          </button>
        </div>
      </div>
      <div
        v-if="detail.wp_password"
        class="mt-3.5 flex flex-wrap items-start md:flex-nowrap"
      >
        <div class="flex items-center">
          <img
            :src="cdn('images/lock-icon.svg')"
            class="mr-2"
            alt=""
            srcset=""
          >
          <h4 class="w-32 text-base font-medium text-grayCust-600 md:text-sm">
            {{ $t('password') }}
          </h4>
        </div>
        <div class="flex items-center">
          <input
            ref="password"
            type="text"
            class="absolute p-0 opacity-0"
            :value="detail.wp_password"
          >
          <p class="username-width ml-2 break-all text-base font-medium text-grayCust-600 md:text-sm">
            {{ detail.wp_password }}
          </p>
          <button
            type="button"
            class="ml-2 cursor-pointer"
            @click="copyToClipboard('password')"
          >
            <Tooltip :tooltip-text="siteDetails.password ? $t('copied') : $t('copy')">
              <CheckIcon
                v-if="siteDetails.password"
                class="size-4 text-grayCust-800"
              />
              <CopyGrayIcon
                v-else
                class="size-4 text-primary-900"
              />
            </Tooltip>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Tooltip from '@/components/New/Blocks/Tooltip/Tooltip.vue';
import CopyGrayIcon from '@/components/UpdatedDesignVersion/ImageComponents/CopyGrayIcon.vue';
import LinkIcon from "@/components/UpdatedDesignVersion/ImageComponents/LinkIcon.vue";
import { CheckIcon } from "@heroicons/vue/outline";

export default {
   
   components:{
      Tooltip,
      CopyGrayIcon,
      CheckIcon,
      LinkIcon
   },
   props:{
      status: {
         default: '',
         type: String,
         required: true
      },
      heading: {
         default: '',//this.$t('installation_in_progress'),
         type: String,
      },
      subHeading: {
         default: '',
         type: String,
      },
      detail: {
         type: Object,
         default() {
            return { wp_url: null, wp_password: null, wp_username: null}
         }
      },
      template: {
         type: Object,
         default() {
            return {}
         }
      },
      price: {
          default: 0,
          type: Number,
      },
   },
   data(){
      return {
         siteDetails: {
            username: null,
            password: null
         },
      }
   },
   computed: {
     websiteUrl() {
         return this.detail.wp_url.replace(/(^\w+:|^)\/\//, '');
      }
   },
   methods:{
      copyToClipboard(type) {
            const that = this;
            that.siteDetails[type] = true;
            const ele = this.$refs[type];
            if (ele) {
                ele.select();
                ele.setSelectionRange(0, 99999);
                document.execCommand('copy');

                that.siteCopiedTimer = setTimeout(() => {
                that.siteDetails[type] = false;
                }, 2000);
            }
        },
   }
}
</script>
<style scoped>
.btn-focus:focus-visible{
    outline: 0 !important;
}
</style>

